<template>
  <div>
      <DxForm   
                :items="items"
                :label-location="labelLocation"
                v-for="(key,index) in lineItems.items"
                :form-data="lineItems.items"                             
                >

            <template #cstm_field="{ data: item }">
                <div>
                    <custom-field-types 
                    :item = item 
                    :prefix="slug"
                    v-model="lineItems.items[index][item.dataField]"                    
                    @change="inputChanged(index,item.dataField)"
                    >
                    </custom-field-types>
                </div>
            </template>        
        <!-- <template #form-item="{ data: item }">
            <div>   
                <div v-if="item.editorType=='dxTextBox'" >
                    
                    <DxTextBox                                          
                        v-model="lineItems.items[index][item.dataField]"                    
                        value-change-event="keyup"
                        @value-changed="inputChanged(index,item.dataField)"/>
                    
                </div>
                <div v-if="item.editorType=='dxNumberBox'">
                    <DxNumberBox
                        v-model="lineItems.items[index][item.dataField]"                    
                        value-change-event="keyup"
                        @value-changed="inputChanged(index,item.dataField)"
                    />
                </div>
                <div v-if="item.editorType=='Relate'">                    
                    <DropDataGrid
                        v-model="lineItems.items[index][item.dataField]"
                        :rRoute="item.editorOptions.relateModule"
                    >
                    </DropDataGrid>
                </div>
                <div v-if="item.itemType == 'button'">
                    
                    
                </div>
            </div> 
        </template> -->
        <template #form-button="{ data: item }">
            <DxButton
                icon="trash"            
                @click="removeLine(index)"
            />
        </template>
        <template #form-add-button="{ data: item }">
            <DxButton
                icon="plus" 
                text="Add Phone"           
                @click="addTopLine($event)"
            />
        </template>
        <template #form-value-style="{ data: item }">
            <span class="form-value-style" >
                    pata nahi kya h
                </span>
        </template>   
         
    </DxForm>
    <DxForm   
                :items="btnLayout"
                :label-location="labelLocation"
                v-for="(key,index) in btnLayout"
                :form-data="btnLayout"                             
                >

            <template #form-add-button="{ data: item }">
            <DxButton
                icon="plus" 
                text="Add Item"           
                @click="addTopLine($event)"
            />
            </template>
            
            <template #form-total-value="{ data: item }">
                
                    <DxTextBox
                        :value="subTotal"
                        :read-only="true"
                    />
                
            </template>

    </DxForm>    
    
    <DxForm :items="items2"   
                :label-location="labelLocation"             
                v-for="(key,index) in lineItems.ledgers"
                :form-data="lineItems.ledgers" >

            <template #form-value-style="{ data: item }">
                <span class="form-value-style" >
                        {{ item.editorOptions.value }}
                </span>
            </template>
            <template #form-button="{ data: item }">
                <DxButton
                    icon="trash"            
                    @click="removeBottomLine(index)"
                />
            </template>
            <template #cstm_field="{ data: item }">
                <div> 
                    <custom-field-types 
                    :item = item 
                    :prefix="slug"
                    v-model="lineItems.ledgers[index][item.dataField]">
                    </custom-field-types>
                </div>
            </template>
            
    </DxForm>

    <DxForm   
            :items="totalLayout"
            :label-location="labelLocation"
            v-for="(key,index) in totalLayout"
            :form-data="totalLayout"                             
            >

            <template #form-total-button="{ data: item }">
            <DxButton
                icon="plus" 
                text="Add Line"           
                @click="addBottomLine($event)"
            />
            </template>

    </DxForm>

    <!-- <div class="line-add-button">
        <DxButton
            
            text="Add Line"
            type="normal"
            icon="plus"
            styling-mode="contained"
            @click="addBottomLine($event)"
        />
    </div> -->

  </div>
</template>

<script>
import {
  DxForm,
  DxSimpleItem,
  DxLabel
} from 'devextreme-vue/form';

import DxTextBox from 'devextreme-vue/text-box'; 
import DxNumberBox from 'devextreme-vue/number-box';
import DxButton from 'devextreme-vue/button';
import DropDataGrid from "./DropDataGrid.vue";
import CustomFieldTypes from "./CustomFieldTypes.vue"; 
import {getInvoiceItemLayoutDef} from '../Pages/Builder/base.js';

export default {
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
            required: true
        },
        slug:String,
        defaultData:
        {
            type: Array,
            default: [],
        },
        fname:String,
        modRoute:String,
    },
    components: {
        DxForm,
        DxSimpleItem,
        DxButton,
        DxLabel,
        DxTextBox,
        DropDataGrid,
        CustomFieldTypes,
        DxNumberBox
    },
    data:function()
    {
        return {
                
                formData:{},
                formDataArray:[],
                grandTotal:0,
                subTotal:"0",
                LineCount:2,
                labelLocation: 'top',
                lineItems:{items:[],ledgers:[]},
                items:[],
                test:{
                            itemType: 'group',
                            colSpan: 2,
                            items: [{
                                dataField: 'Gst',
                                template: "form-value-style",
                                editorOptions: {
                                    width: '200',
                                },
                                }, {
                                dataField: 'Discount',
                                template: "form-value-style",
                                editorOptions: {
                                    width: '200',
                                },
                                }, {
                                dataField: 'Total',
                                template: "form-value-style",                                
                                editorOptions: {
                                    width: '200',
                                    value: "000"
                                },
                                }],
                        },
                items2:[],        
                items3:[
                    {
                        itemType: 'group',
                        cssClass: 'first-group',
                        colCount: 4,
                        items: [{
                            itemType: 'empty',
                            colSpan: 2,
                        },
                        ],
                    }
                ],

                btnLayout:[{
                    itemType: 'group',
                    cssClass: 'line-add-button',
                    colCount: 2,
                    items: [
                        {                                                        
                            template: "form-add-button",
                            
                        },
                        {
                            dataField: 'Total',
                            template: "form-total-value",                           
                            label:{
                                text: "Total",
                                location:"left",
                                alignment:"right"
                            },
                            editorOptions: {
                                    readOnly:true,
                                    width: '200',
                                    value: "000"
                                },
                        }

                    ],
                }],
                totalLayout:[{
                    itemType: 'group',
                    cssClass: 'line-add-button',
                    colCount: 2,
                    items:[
                        {                                                        
                            template: "form-total-button",                            
                        },
                        {
                            dataField: 'GrandTotal',                            
                            label:{
                                text: "Grand Total",
                                location:"left",
                                alignment:"right"
                            },
                            editorOptions: {
                                    readOnly:true,
                                    width: '200',
                                    value: "000"
                                },
                        }

                    ],
                }],
                address: {
                    address_line_1: '',
                    address_line_2: '',
                    city: '',
                    province: '',
                    postal_code: ''
                }            
            }
    },
    methods: {
            showMessage() {
                alert("done");
            },
            inputChanged(indx,key) {
                
                                 
                this.$emit('update:modelValue', this.lineItems);
                
                //console.log(this.items2);  
                //loop field def
                //check for total and field calculation
                //first time loop on all field then only change field
                this.fieldCalfunction(indx,key);
                //this.addTotalFields();   
                       
                
            },
            fieldCalfunction(indx,key){
                     
                //for singal  need to call calfunction like listener
                let fieldArr = this.items[0].items[0].items;
                let obj = fieldArr.find(o => o.dataField === key);
                if(obj.editorOptions)
                {   if(obj.editorOptions.total && obj.editorOptions.total == "true")
                    {
                        this.getValueOf(obj.dataField);
                    }
                    
                }
                
                
            },
            addTotalFields()
            {
                let arr = this.items[0].items[0].items;
                arr.forEach(element => {                    
                    if(element.editorOptions && element.editorOptions.total && element.editorOptions.total == "true")
                    {                        
                        this.getValueOf(element.dataField);
                          
                    }
                });
            },
            getValueOf(field)
            {
                let sum = 0;
                for (let index = 0; index < this.lineItems.items.length; index++) {
                    let a = this.lineItems.items[index][field];
                    sum = Number(a)+Number(sum);                            
                }
                this.lineItems["sum_of_"+field] = sum;
                this.subTotal = sum.toString();
                
            },
            removeBottomLine(index)
            {
                if (index > 0) {
                    this.lineItems.ledgers.splice(index, 1);
                }
            },
            
            removeLine(index)
            {
                //this.LineCount--;
                if (index > 0) {
                    /* let obj = this.getNewObj();
                    for (let [key, val] of Object.entries(obj)) {
                        
                        //console.log([key]+(index));
                        this.formData[[key]+(index)] = val;
                    }    */
                    this.lineItems.items.splice(index, 1);
                }
                
            },
            addTopLine()
            {   
                this.lineItems.items.push(this.getNewObj());   
            },
            getNewObj()
            {   
                let arr = this.items[0].items[0].items;                
                var object = arr.reduce(
                    (obj, item) => Object.assign(obj,  (( "dataField" in item ) && {  [item.dataField]: "" })), {});
                
                return object;
            },
            addBottomLine()
            {
                this.lineItems.ledgers.push(this.getBottomObj());
                //this.items2.push(this.getBottomObj());
            },
            getBottomObj()
            {
                let arr = this.items2[0].items[0].items;
                var object = arr.reduce(
                    (obj, item) => Object.assign(obj,  (( "dataField" in item ) &&{  [item.dataField]: "" })), {});

                return object;
            },
            getFormDef(fname)
            {
            
                getInvoiceItemLayoutDef(this.modRoute,fname,false).then(response => {
                            
                    this.items = Object.values(response.data.top);
                    //this.items.push(this.btnLayout);
                    this.items2 = Object.values(response.data.bottom);
                    this.LineCount = this.items2[0].items[0].items.length;
                    ///console.log(this.items2[0].items[0].items.length);
                    //set blank first row
                    if(this.lineItems.items.length < 1) {                
                        this.lineItems.items[0]= this.getNewObj();                        
                    }
                    
                    if(this.lineItems.ledgers.length < 1) {                
                        this.lineItems.ledgers[0]= this.getBottomObj();                        
                    }
                    
                });
                
            }
            
        },
        created: function()
        {
            

            //get form data fpr line item
            this.getFormDef(this.fname);

            //this.items2[0].items.push(this.test);
            
            /* //set blank first row
            if(this.modelValue.length < 1) {                
                this.modelValue[0]= this.getNewObj();
            } */
            
            //filter

        },
        computed: {
            
        },
    mounted() {  
            
        document.querySelectorAll('.someclass').forEach(item => {
            item.addEventListener('change', event => {
                //console.log(item.apple);
                var inputNodes = item.getElementsByTagName('INPUT');
                for(var i = 0; i < inputNodes.length; ++i){
                    var inputNode = inputNodes[i];
                    if(inputNode.type == 'text') {
                        //Do whatever you want
                        
                    }
                }
            })
        })
    },
}
</script>

<style>
.line-add-button
{
    margin-top: 5px;
    margin-bottom: 5px;
}
.deleteCell
{
    
    margin-top: auto;
    margin-right: auto;
    margin-right: auto;
    
}


.group-item 
> .dx-field-item-content
> .dx-form-group
> .dx-form-group-content
> .dx-layout-manager
> .dx-widget
> .dx-box-flex
> .dx-item
> .dx-item-content
> .dx-item
{
    flex: initial  !important;
} 

.form-value-style{
    font-weight: 600;
    align-content: right;
}
</style>